import type { IconProps } from './types';

export const WarningIcon = (props: IconProps) => {
  const {
    width = 20,
    height = 18,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
    >
      <path
        d="M8.76604 1.84063L1.25324 14.7197C0.697694 15.6721 1.38465 16.8681 2.48722 16.8681H17.5129C18.6154 16.8681 19.3023 15.6721 18.7467 14.7197L11.234 1.84063C10.6827 0.895633 9.3173 0.895633 8.76604 1.84063Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.15383V10.7967"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1067 13.6541C11.1066 14.2654 10.6115 14.7604 10.0003 14.7606C9.42723 14.7606 8.9556 14.3256 8.89874 13.7674L8.89288 13.6541L8.89874 13.5408C8.95535 12.9824 9.42704 12.5467 10.0003 12.5467L10.1136 12.5525C10.6716 12.6094 11.1067 13.0809 11.1067 13.6541Z"
        fill={color}
      />
    </svg>
  );
};
